import { getEncryptToBase64 as encrypt, getDecryptByBase64 as decrypt } from "../../router/utils/encryption"
// import { getEncrypt as encrypt, getDecrypt as decrypt } from "../../router/utils/encryption"
const encodeReserveRE = /[!'()*]/g
const encodeReserveReplacer = c => '%' + c.charCodeAt(0).toString(16)
const commaRE = /%2C/g

const encode = str => encodeURIComponent(str)
    .replace(encodeReserveRE, encodeReserveReplacer)
    .replace(commaRE, ',')

const decode = decodeURIComponent

 // // 返回参数对象
 function queryURLParams() {
    let pattern = /(\w+)=(\w+)/ig; //定义正则表达式
    let parames = {}; // 定义参数对象
    // console.log(window.location)
    let url=window.location.href
    url.replace(pattern, ($, $1, $2) => {
      parames[$1] = $2;
    });
    return parames;
  }






/**
 * 序列化对象 并加密
 * @param {Object} obj
 */
export const stringifyQuery = obj => {
    
    
    // 序列化方法使用的vue-router中的原方法，详见vue-router/src/query.js
    // 唯一的修改时最后返回的时候，对参数进行了加密
    const res = obj ? Object.keys(obj).map(key => {
        const val = obj[key]

        if (val === undefined) {
            return ''
        }

        if (val === null) {
            return encode(key)
        }

        if (Array.isArray(val)) {
            const result = []
            val.forEach(val2 => {
                if (val2 === undefined) {
                    return
                }
                if (val2 === null) {
                    result.push(encode(key))
                } else {
                    result.push(encode(key) + '=' + encode(val2))
                }
            })
            return result.join('&')
        }

        return encode(key) + '=' + encode(val)
    }).filter(x => x.length > 0).join('&') : null

    let queryList=queryURLParams()
    if(queryList.lcfxbgtype=="2")//判断是否为分析报告页面  是2的话就不加密
    {
        return res ? `?${res}` : ''
    }else{
        return res ? `?${encrypt(res)}` : ''
    }    
}

/**
 * 解密 解析 字符串参数
 * @param {String}} query
 */
export const parseQuery = query => {
    // 先对query进行解密
    // 在使用vue-router中的解析方法对query进行解析，详见vue-router/src/query.js
    const res = {}
    query = query.trim().replace(/^(\?|#|&)/, '')
    if (!query) {
        return res
    }

    // 解密
    let queryList=queryURLParams()
    if(queryList.lcfxbgtype=="2")//判断是否为分析报告页面  是2的话就不加密
    {
        query = query;
    }else{
        query = decrypt(query);
    }
    // 
    
    query.split('&').forEach(param => {
        const parts = param.replace(/\+/g, ' ').split('=')
        const key = decode(parts.shift())
        const val = parts.length > 0
            ? decode(parts.join('='))
            : null

        if (res[key] === undefined) {
            res[key] = val
        } else if (Array.isArray(res[key])) {
            res[key].push(val)
        } else {
            res[key] = [res[key], val]
        }
    })
    return res
}


// WEBPACK FOOTER //
// ./src/router/utils/query.js